import { useParams } from "react-router-dom";
import { Certificate } from "../components/Certificate";
import { getCertificate } from "../lib/helper";
import { shallowEqual, useSelector } from "react-redux";
import { IState } from "../lib/store";

const get = (year: string, grade: string, program: string, hash: string) => (state: IState) => {
    return getCertificate(hash, state.projects.certificates[year!][grade!][program!])
}


export const CerficatePreview: React.FC = () => {
    const { year='', grade='', program='', hash='' } = useParams();
    const certificate = useSelector(get(year, grade, program, hash), shallowEqual);

    return <Certificate certificate={certificate} />
}